// TSP mode switching utilities
import { useState, useCallback, useEffect, useRef } from 'react';

// Mode constants
export const MODES = [
  'Setup Points',    // Setup mode - Add and manage location points
  'Custom Path',     // Custom mode - Manually plan path
  'Auto Path',       // Auto mode - Algorithm solves path
  'Compare Paths'    // Compare mode - Compare different paths
];

// Setup mode submodes
export const SETUP_SUBMODES = {
  MAP: 'Map Points',      // Add points by clicking on map
  MANUAL: 'Manual Input'  // Add points by manually entering coordinates
};

export const useModeSwitching = () => {
  const [currentMode, setCurrentMode] = useState(MODES[0]);
  const [setupSubmode, setSetupSubmode] = useState(SETUP_SUBMODES.MAP);
  const currentModeRef = useRef(currentMode);
  
  // Update mode reference when mode changes
  useEffect(() => {
    currentModeRef.current = currentMode;
  }, [currentMode]);
  
  // Submode switching handler
  const handleSubmodeSwitching = useCallback((submode) => {
    if (Object.values(SETUP_SUBMODES).includes(submode)) {
      setSetupSubmode(submode);
    }
  }, []);
  
  return {
    currentMode, 
    setCurrentMode,
    currentModeRef,
    setupSubmode, 
    setSetupSubmode,
    handleSubmodeSwitching
  };
};

export const getActiveModeName = (currentMode) => currentMode || MODES[0];
export const isAutoMode = (mode) => mode === MODES[2];
export const isCustomMode = (mode) => mode === MODES[1];
export const isSetupMode = (mode) => mode === MODES[0];
export const isCompareMode = (mode) => mode === MODES[3]; 